/* eslint-disable spire/export-styles */
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedBrandPath, getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const categoryPath =
        getSelectedCategoryPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    const catalogPageState = getCatalogPageStateByPath(state, categoryPath);
    const { pathname } = getLocation(state);
    const brandPath = getSelectedBrandPath(state) || pathname;
    return {
        currentPage: getCurrentPage(state),
        catalogPageState,
        breadCrumbs: state.components.breadcrumbs.links,
        categoryFacets: getProductListDataViewProperty(state, "properties"),
        brandPath,
    };
};

export interface CategoryNameStyles {
    container?: InjectableCss;
    bannerBrandHeading?: InjectableCss;
}

export const categoryNameStyles: CategoryNameStyles = {
    container: {
        css: css`
            padding-top: 15px !important;
        `,
    },
    bannerBrandHeading: {
        css: css`
            font-size: 20px !important;
            line-height: normal !important;
            text-transform: capitalize;
        `,
    },
};

const styles = categoryNameStyles;
type Props = WidgetProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;

const CategoryName = ({ category, currentPage, breadCrumbs, catalogPageState, brandPath, categoryFacets }: Props) => {
    const subCategories =
        catalogPageState?.value?.properties?.subCategories &&
        JSON.parse(decodeURI(catalogPageState?.value?.properties?.subCategories));

    const isBrandPath = brandPath?.toLowerCase()?.includes("/brands");
    const categoryFacetsData = JSON.parse(categoryFacets?.categoryList ?? "[]");

    const lastLevelCategory = breadCrumbs?.[breadCrumbs?.length - 1]?.children;
    const categoryFacetsDataNew = categoryFacetsData?.filter((item: any) => item.Name !== lastLevelCategory);

    if (
        !category ||
        (categoryFacetsDataNew?.length === 0 && isBrandPath) ||
        (subCategories?.length === 0 && !isBrandPath) ||
        !subCategories
    ) {
        return null;
    }

    const categoryPath = category.path;
    // console.log("categoryPath",categoryPath)

    const shouldDisplayBrand = categoryPath && categoryPath.toLowerCase()?.includes("/brands");
    const breadCrumbArray = breadCrumbs?.map(item => item.children);
    const brandName = breadCrumbArray?.[2];
    const isSearchCrawler = getIsWebCrawler();

    return (
        <>
            {shouldDisplayBrand ? (
                <Typography
                    variant="h1"
                    data-test-selector={`category_BrandName_${category.shortDescription ?? category.name}_${brandName}`}
                >
                    {" "}
                    {category.shortDescription ?? category.name} - {brandName}
                </Typography>
            ) : (
                <Typography
                    variant={isSearchCrawler && currentPage.type === "CategoryDetailsPage" ? "h1" : "h1"}
                    data-test-selector={`categoryName_${category.shortDescription ?? category.name}`}
                    {...styles.container}
                >
                    {category.shortDescription ?? category.name}
                </Typography>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CategoryName)),
    definition: {
        group: "Category Details",
        icon: "folder-bookmark",
        allowedContexts: ["CategoryDetailsPage", "ProductDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
